/**
 * Tags semânticas para `ui_action` no evento GA4 `ui_message`.
 * Usar apenas quando há intenção/ação explícita do usuário (confirmações, fluxos guiados).
 * Erros genéricos de API (`showErrorAlert`, fallbacks) não devem preencher.
 */
export const UI_ACTION = {
  // Sessão / conta
  LOGOUT_CONFIRM: 'logout_confirm',
  CANCEL_REGISTER_CONFIRM: 'cancel_register_confirm',
  REMOVE_ACCOUNT_CONFIRM: 'remove_account_confirm',
  REMOVE_CLIENT_CONFIRM: 'remove_client_confirm',
  ACCOUNT_REMOVED_SUCCESS: 'account_removed_success',

  // Carrinho / pedido
  LEAVE_ORDER_EDIT_CONFIRM: 'leave_order_edit_confirm',
  CANCEL_ORDER_EDIT_SUCCESS: 'cancel_order_edit_success',
  CANCEL_ORDER_CONFIRM: 'cancel_order_confirm',
  ORDER_CANCELLED_SUCCESS: 'order_cancelled_success',
  ORDER_EDIT_SUCCESS: 'order_edit_success',
  CLEAR_CART_CONFIRM: 'clear_cart_confirm',
  REMOVE_CART_ITEM_CONFIRM: 'remove_cart_item_confirm',
  LOSE_PROMO_ON_REMOVE_CONFIRM: 'lose_promo_on_remove_confirm',
  CART_EMPTY_ON_EDIT: 'cart_empty_on_edit',
  SWITCH_TO_REDEEM_CART_CONFIRM: 'switch_to_redeem_cart_confirm',
  SWITCH_TO_REGULAR_CART_CONFIRM: 'switch_to_regular_cart_confirm',
  CHECKOUT_REDIRECT_CART: 'checkout_redirect_cart',
  CHECKOUT_PAYMENT_FAILED_RETRY: 'checkout_payment_failed_retry',
  CHECKOUT_CANCEL_ORDER_CONFIRM: 'checkout_cancel_order_confirm',
  ORDER_EDIT_TIMEOUT_ACK: 'order_edit_timeout_ack',
  ORDER_INVOICE_FORMAT_PICK: 'order_invoice_format_pick',
  ORDER_INVOICE_UNAVAILABLE: 'order_invoice_unavailable',

  // Clube / resgate
  CLUB_REGULATION_ACCEPT: 'club_regulation_accept',
  REDEEM_EMPTY_CART: 'redeem_empty_cart',
  REDEEM_MIN_POINTS_NOT_MET: 'redeem_min_points_not_met',
  REDEEM_APPROVED_SUCCESS: 'redeem_approved_success',
  REDEEM_SELECT_CARD_REQUIRED: 'redeem_select_card_required',

  // Pagamento / PIX / dívidas
  PIX_EXPIRED_RENEW: 'pix_expired_renew',
  PIX_PAID_SUCCESS: 'pix_paid_success',
  PIX_INVALID: 'pix_invalid',
  DEBT_SELECT_REQUIRED: 'debt_select_required',
  DEBT_PAYMENT_SUCCESS: 'debt_payment_success',
  PAYMENT_QRCODE_SUCCESS: 'payment_qrcode_success',

  // Cartões
  REMOVE_CARD_CONFIRM: 'remove_card_confirm',

  // Cadastro / onboarding
  INTRO_CONTINUE: 'intro_continue',
  REGISTER_STATUS_ACTIVE: 'register_status_active',
  REGISTER_STATUS_BLOCKED: 'register_status_blocked',
  REGISTER_STATUS_CANCELED: 'register_status_canceled',
  REGISTER_STATUS_REVIEW: 'register_status_review',
  REGISTER_COMPLETED_SUCCESS: 'register_completed_success',
  PASSWORD_CHANGED_SUCCESS: 'password_changed_success',
  PASSWORD_CREATED_INFO: 'password_created_info',
  UPLOAD_FILE_SOURCE_PICK: 'upload_file_source_pick',

  // QR Code / SFCoke
  QRCODE_NOT_SUPPORTED: 'qrcode_not_supported',
  QRCODE_WRONG_USER: 'qrcode_wrong_user',
  QRCODE_INVALID: 'qrcode_invalid',
  SFCOKE_QRCODE_REQUIRED: 'sfcoke_qrcode_required',
  SFCOKE_PAYMENT_NOT_ALLOWED: 'sfcoke_payment_not_allowed',

  // Restrições de fluxo
  CANNOT_CHANGE_DELIVERY_WHILE_EDITING: 'cannot_change_delivery_while_editing',
  PAYMENT_SLIP_NO_ID: 'payment_slip_no_id',
} as const;

export type UiMessageAction = (typeof UI_ACTION)[keyof typeof UI_ACTION];
